<template>
  <div style="padding:10px;background:#eee">
    以下为引用数据
    <UgoForm
      ref = "form"
      :form="fields"
      :editable="false"
      :as_view="as_view !== false"
      :value="formData"
    >
    </UgoForm>
  </div>
</template>

<script>
import asViewMixin from '../mixins/as-view';
export default {
  mixins: [asViewMixin],
  methods: {
    getValueDef() {
      return null;
    },
  },
  cname: '数据引用',
  corder: 90,
  icon: 'danxuan',
  data() {
    return {
      formData: {},
    };
  },
  computed: {
    fields() {
      return [];
    },
  },
  properties: [
    {
      label: '引用内容',
      key: 'ref',
      control: 'FieldSelect',
    },
  ],
};
</script>

<style lang="less" scoped>

</style>
